<template>
  <div id="singlecard">
    <div class="progress-header">
      <div
        class="header-side"
        :style="{
          visibility: !contentData.backButton.hidden ? 'visible' : 'hidden',
        }"
      >
        <v-btn
          @click="submitAnswerFromCard('back')"
          class="prg-header-btn"
          rounded
          icon
        >
          <v-icon size="36px" class="prg-header-icon">mdi-chevron-left</v-icon>
        </v-btn>
        <div class="btn-text">
          <a @click="submitAnswerFromCard('back')">{{
            contentData.backButton.text
          }}</a>
        </div>
      </div>
      <div class="progress-bar" :style="{ visibility: 'hidden' }">
        <v-progress-linear :value="progress" height="25">
          <template v-slot:default="{ value }">
            <strong>{{ Math.ceil(value) }}%</strong>
          </template>
        </v-progress-linear>
      </div>
      <div
        :style="{
          visibility: !contentData.nextButton.hidden ? 'visible' : 'hidden',
        }"
        class="header-side"
      >
        <div class="btn-text">
          <a @click="submitAnswerFromCard('next')">{{
            contentData.nextButton.text
          }}</a>
        </div>
        <v-btn
          @click="submitAnswerFromCard('next')"
          class="prg-header-btn"
          rounded
          icon
        >
          <v-icon size="36px" class="prg-header-icon">mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
    <section class="anni-section">
      <div class="left">
        <div class="avatar">
          <img
            alt="anni logo"
            width="200px"
            height="200px"
            src="../assets/ANNI_Design_Round_Image_Green.png"
          />
        </div>
      </div>
      <div class="body">
        <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
        <div class="text-semibold">
          {{ contentData.question.title }}
        </div>
        <div class="text-regular">
          {{ contentData.question.subtitle }}
        </div>
        <img class="quote-bottom" alt="anni logo" src="../assets/quotes.svg" />
      </div>
    </section>

    <section class="response-placeholder">
      <table-card v-if="componentToggles.tableCard" />

      <text-box
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        @showLoadingModal="showLoadingModal($event)"
        ref="textBox"
        v-else-if="componentToggles.textBox"
      />

      <chips-card
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        @showFeatureUnavailableModal="showFeatureUnavailableModal($event)"
        @reportNewTopicModal="reportNewTopicModal()"
        ref="chipsCard"
        v-else-if="componentToggles.chipsCard"
      />

      <process-card
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="processCard"
        v-else-if="componentToggles.processCard"
      />

      <product-card v-else-if="componentToggles.productCard" />

      <buttons-card
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="buttonsCard"
        v-else-if="componentToggles.buttonsCard"
      />

      <filter-box
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="filterBox"
        v-else-if="componentToggles.filterBox"
      />

      <checkmark-box
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="checkmarkBox"
        v-else-if="componentToggles.checkmarkBox"
      />

      <contact-detail-card
        @submitAnswer="forwardMultipleAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="contactDetailCard"
        v-else-if="componentToggles.contactDetailCard"
      />
      <contact-detail-card-extended
        @submitAnswer="forwardMultipleAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="contactDetailCardExtended"
        v-else-if="componentToggles.contactDetailCardExtended"
      />

      <drop-down-card
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="dropDownCard"
        v-else-if="componentToggles.dropDownCard"
      />

      <signature-card
        @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
        @readyToUpdate="updateResponseComponentContent()"
        ref="signatureCard"
        v-else-if="componentToggles.signatureCard"
      />

      <empty-card ref="emptyCard" v-else-if="componentToggles.emptyCard" />
    </section>
  </div>
</template>
<script>
import EmptyCard from "../components/SingleCard/EmptyCard.vue";
import TableCard from "../components/SingleCard/TableCard.vue";
import TextBox from "../components/SingleCard/TextBox.vue";
import ChipsCard from "../components/SingleCard/ChipsCard.vue";
import ProcessCard from "../components/SingleCard/ProcessCard.vue";
import ProductCard from "../components/SingleCard/ProductCard.vue";
import ButtonsCard from "../components/SingleCard/ButtonsCard.vue";
import FilterBox from "../components/SingleCard/FilterBox.vue";
import CheckmarkBox from "../components/SingleCard/CheckmarkBox.vue";
import ContactDetailCard from "../components/SingleCard/ContactDetailCard.vue";
import DropDownCard from "../components/SingleCard/DropDownCard.vue";
import ContactDetailCardExtended from "../components/SingleCard/ContactDetailCardExtended.vue";
import SignatureCard from "../components/SingleCard/SignatureCard.vue";

const guiTemplateMapping = {
  TitleAndSubtitleWith2Buttons: "buttonsCard",
  TitleAndSubtitleWithTextbox: "textBox",
  TitleAndSubtitleWithCheckboxContainers: "filterBox",
  TitleAndSubtitleWithChips: "chipsCard",
  TitleAndSubtitleWithProcessOverview: "processCard",
  TitleAndSubtitleWithCheckmarkBox: "checkmarkBox",
  TitleAndSubtitleWithContactDetails: "contactDetailCard",
  TitleAndSubtitleWithContactDetailsExtended: "contactDetailCardExtended",
  TitleAndSubtitleWithDropDown: "dropDownCard",
  TitleAndSubtitleWithSignature: "signatureCard",
  TitleAndSubtitleNothingElse: "emptyCard",
};

export default {
  components: {
    EmptyCard,
    TextBox,
    TableCard,
    ChipsCard,
    ProcessCard,
    ButtonsCard,
    ProductCard,
    FilterBox,
    CheckmarkBox,
    ContactDetailCard,
    DropDownCard,
    ContactDetailCardExtended,
    SignatureCard,
  },
  data() {
    return {
      progress: 68,
      componentToggles: {
        tableCard: false,
        chipsCard: false,
        textBox: false,
        processCard: false,
        productCard: false,
        buttonsCard: false,
        filterBox: false,
        checkmarkBox: false,
        contactDetailCard: false,
        dropDownCard: false,
        contactDetailCardExtended: false,
        signatureCard: false,
        emptyCard: false,
      },
      contentData: {
        question: {
          title:
            "QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG ",
          subtitle:
            "QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE",
        },
        nextButton: {
          text: "nächste Frage",
          hidden: false,
        },
        backButton: {
          text: "zurück",
          hidden: false,
        },
      },
      executableSystemAction: {},
    };
  },
  methods: {
    forwardAnswerToAppForBackendProcessing(data) {
      this.$emit("forwardAnswerToAppForBackendProcessing", data);
    },
    forwardMultipleAnswerToAppForBackendProcessing(data) {
      this.$emit("forwardMultipleAnswerToAppForBackendProcessing", data);
    },

    // updates the question in the screen and triggers updates + visibility of required response components
    updateQuestionAndResponse(executableSystemAction) {
      console.log(executableSystemAction);

      this.executableSystemAction = executableSystemAction;

      // update title + subtitle
      this.contentData.question.title =
        executableSystemAction.guiTemplateContent.title.text;
      this.contentData.question.subtitle =
        executableSystemAction.guiTemplateContent.subtitle.text;

      // assign title of nextButton if defined, otherwise hide
      if ("nextButton" in executableSystemAction.guiTemplateContent) {
        this.contentData.nextButton.text =
          executableSystemAction.guiTemplateContent.nextButton.text;
        this.contentData.nextButton.hidden = false;
      } else {
        this.contentData.nextButton.hidden = true;
      }

      // assign title of backButton if defined, hide if specified
      if (
        typeof executableSystemAction.guiTemplateContent.backButton !==
        "undefined"
      ) {
        // assign text if specified
        if (
          typeof executableSystemAction.guiTemplateContent.backButton.text !==
          "undefined"
        ) {
          this.contentData.backButton.text =
            executableSystemAction.guiTemplateContent.backButton.text;
        } else {
          this.contentData.backButton.text = "zurück";
        }
        // hide if specified
        if (
          typeof executableSystemAction.guiTemplateContent.backButton.hidden !==
          "undefined"
        ) {
          this.contentData.backButton.hidden =
            executableSystemAction.guiTemplateContent.backButton.hidden;
        } else {
          this.contentData.backButton.hidden = false;
        }
      } else {
        this.contentData.backButton.hidden = false;
      }

      // decide based on guiTemplate which component in this screen to update
      this.showResponseComponent(
        guiTemplateMapping[executableSystemAction.guiTemplate]
      );
    },
    // shows the desired component, hides the rest by assigning true/false to data.componentToggles
    showResponseComponent(componentToShow) {
      console.log("TOGGLING COMPONENT VISIBILITY");
      console.log(componentToShow);
      for (let component of Object.keys(this.$data.componentToggles)) {
        this.$data.componentToggles[component] = componentToShow == component;
      }
      console.log(this.$data.componentToggles);

      // call the updateContent function even when the component was not mounted/destroyed => for cases when identical components after another are used
      this.$refs[
        guiTemplateMapping[this.executableSystemAction.guiTemplate]
      ].updateContent(this.executableSystemAction);
    },

    // used to handle button events directly from this card (next/previous button), not from child components
    submitAnswerFromCard(input) {
      let newInput = {};

      // switch statement as prep for upcoming onCard events besides next
      switch (input) {
        case "next":
          newInput = {
            nextButton: {
              clicked: true,
            },
          };
          break;
        case "back":
          newInput = {
            backButton: {
              clicked: true,
            },
          };
          break;
      }
      this.$emit("forwardAnswerToAppForBackendProcessing", newInput);
    },

    // calls the update content for the right Vue component based on the provided mapping
    // TODO => fix first time mounted
    updateResponseComponentContent() {
      this.$refs[
        guiTemplateMapping[this.executableSystemAction.guiTemplate]
      ].updateContent(this.executableSystemAction);
    },
    showFeatureUnavailableModal(selectedTopic) {
      this.$emit("showFeatureUnavailableModal", selectedTopic);
    },
    reportNewTopicModal() {
      this.$emit("reportNewTopicModal");
    },
    showLoadingModal(loadingData) {
      this.$emit("showLoadingModal", loadingData);
    },
  },
  mounted() {
    console.log("mount SINGLE");
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate");
    });
  },
  destroyed() {
    //TODO: switch to unmount when upgrade to Vue3
    console.log("unmount SINGLE");
  },
};
</script>
